import React from "react";
import moment from "moment";
import { useState } from "react";
import EventModal from "./EventModal";
import { withNamespaces } from "react-i18next";

const Event = ({ event, number, language, t }) => {
  const [eventModalOpen, toggleEventModal] = useState(false);
  const { title, begin, location } = event.fields;
  const dayToday = moment(begin).format("DD");
  const isInThePast = moment(begin).isBefore(moment());
  return (
    <div className={isInThePast ? "item old-event" : "item"}>
      {/* <div className="first-view">
				<h3>{language ? moment(begin).format('DD.MM.YYYY') : moment(begin).format('MM-DD-YYYY')}</h3>
				<h5>{title}</h5>
				<p>
					<b>location: </b>
					{location}
					<br />
					<b>begin:</b> {language ? moment(begin).format('HH:mm') : moment(begin).format('h:mm A')}
				</p>
				<button id="calendar-1" className="view-more" onClick={() => toggleEventModal(true)}>
					more information
				</button>
			</div> */}

      <div className="calendar-inner-grid">
        <div className="item">
          <p>{dayToday}</p>
        </div>
        <div className="item">
          <h2>{title}</h2>
          <p>
            {location} |{" "}
            {language
              ? moment(begin).format("HH:mm")
              : moment(begin).format("h:mm A")}
          </p>
          <button
            type="button"
            className="view-more-btn"
            onClick={() => toggleEventModal(true)}
          >
            {t("more information")}
          </button>
        </div>
      </div>
      <EventModal
        event={event}
        eventModalOpen={eventModalOpen}
        language={language}
        onClose={() => toggleEventModal(false)}
      />
    </div>
  );
};

export default withNamespaces()(Event);
